import type { Middleware } from '@reduxjs/toolkit'
import { addBreadcrumb } from './error-reporting'

// redux-persist + RTK Query internals fire constantly and say nothing about
// what the user did
const IGNORED_ACTION_PREFIXES = ['persist/', '__rtkq/']

/**
 * Records every dispatched action type as a breadcrumb, so an error-tracking
 * issue shows the actions that led up to it. Types only: payloads can carry
 * user content and tokens.
 */
export const reduxBreadcrumbsMiddleware: Middleware = () => next => action => {
  const type = (action as { type?: unknown })?.type
  if (
    typeof type === 'string' &&
    !IGNORED_ACTION_PREFIXES.some(prefix => type.startsWith(prefix))
  ) {
    addBreadcrumb({ category: 'redux.action', message: type })
  }
  return next(action)
}
